/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { t } from 'utils/translates';

import {
  sendRequest as createTaskExecSendRequest,
  selectRequestState
} from 'mt-react-common/modules/tasks/common/reducers/execCreateForm';

const CreateExecButton = props => {
  const hasShowCreateExecButton =
    !props.task.isFullReserved && [1].includes(props.task.status);
  const modalId = `modalBeginExecution-${props.modalIndex}`;

  const handleShow = () => {
    // eslint-disable-next-line no-undef
    $(`#${modalId}`).modal('show');
  };

  const handleClose = e => {
    e.preventDefault();
    // eslint-disable-next-line no-undef
    $(`#${modalId}`).modal('hide');
  };

  return (
    <div className={props.className}>
      <div
        aria-labelledby="myModalLabel"
        className="modal fade"
        id={modalId}
        role="dialog"
        tabIndex="-1"
        onClick={handleClose}
      >
        <div
          className="modal-dialog modal-gray modal-sm"
          onClick={e => e.stopPropagation()}
        >
          <div className="modal-content">
            <div className="modal-header text-center">
              <a
                aria-label="Close"
                className="close close-black"
                href={null}
                onClick={handleClose}
              />
              <i className="fa fa-exclamation-triangle modal-icon" />
              <h4 className="modal-title">
                <strong>{t('Подтверждение')}</strong>
              </h4>
            </div>
            <div className="modal-body text-center">
              {t('Вы действительно хотите начать выполнение?')}
            </div>
            <div className="modal-footer">
              <a
                className="btn btn-muted"
                data-dismiss="modal"
                href=""
                type="button"
              >
                {t('Отмена')}
              </a>
              <a
                className={classNames('btn btn-success', {
                  disabled: props.requestState.hasInProgress
                })}
                href=""
                type="button"
                onClick={e => {
                  handleClose(e);
                  props.createTaskExecSendRequest();
                }}
              >
                {t('Начать выполнение')}
              </a>
            </div>
          </div>
        </div>
      </div>
      {hasShowCreateExecButton ? (
        <div className="form-group">
          <a
            className={classNames('btn btn-success btn-block', {
              disabled: props.requestState.hasInProgress
            })}
            data-toggle="modal"
            href=""
            onClick={handleShow}
          >
            {props.requestState.hasInProgress ? (
              <span>
                <i
                  className="fa fa-circle-o-notch fa-spin"
                  aria-hidden="true"
                />{' '}
              </span>
            ) : null}
            {t('Выполнить задание')}
          </a>
        </div>
      ) : null}
    </div>
  );
};

CreateExecButton.contextTypes = {
  router: PropTypes.shape()
};

CreateExecButton.defaultProps = {
  className: null
};

CreateExecButton.propTypes = {
  modalIndex: PropTypes.string.isRequired,
  className: PropTypes.string,
  task: PropTypes.shape({
    id: PropTypes.number.isRequired,
    isFullReserved: PropTypes.bool.isRequired,
    status: PropTypes.number.isRequired,
    executorExecutionInterval: PropTypes.number,
    myLastExec: PropTypes.shape({
      status: PropTypes.number
    })
  }).isRequired,

  // CONNECT
  createTaskExecSendRequest: PropTypes.func.isRequired,
  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired,
    hasSuccessQuery: PropTypes.bool
  }).isRequired
};

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state, props) => ({
  requestState: selectRequestState(state, 'tasksModule.forms.execCreateForm')
});

const mapDispatchToProps = (dispatch, props) => ({
  createTaskExecSendRequest: () =>
    dispatch(
      createTaskExecSendRequest(
        'tasksModule.forms.execCreateForm',
        props.task.id
      )
    )
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CreateExecButton)
);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/TaskViewAsExecutor/CreateExecButton/CreateExecButton.js